import axios from "axios";
import * as types from "./mutation_types";

export const retrieve = ({ commit }, values) => {
  commit(types.ASSISE_PARTENAIRE_SHOW_TOGGLE_LOADING);
  axios
    .get("/api/assise/partenaire/" + values.id + "/")
    .then((response) => {
      commit(types.ASSISE_PARTENAIRE_SHOW_TOGGLE_LOADING);
      commit(types.ASSISE_PARTENAIRE_SHOW_SET_RETRIEVED, response.data);
      values.fonction(response.data);
    })
    .catch((e) => {
      commit(types.ASSISE_PARTENAIRE_SHOW_TOGGLE_LOADING);
      commit(types.ASSISE_PARTENAIRE_SHOW_SET_ERROR, e.message);
    });
};

export const reset = ({ commit }) => {
  commit(types.ASSISE_PARTENAIRE_SHOW_RESET);
};
